import { Layout, theme, Space, Table, Button, Modal, TableColumnsType, Spin, Alert, notification, Tag, Input, InputRef, TableColumnType, Row, Col, Divider, Typography, Flex } from 'antd';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import NomineeDetailsModal from '../Molecules/NomineeDetailsModal';
import AdminNomineeModal from '../Molecules/AdminNomineeModal';
import { Form, Checkbox, Select, message } from 'antd';
import TeamDetailsModal from '../Molecules/TeamDetailsModal';
import EligibilityModal from '../Molecules/EligibilityModal';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated } from '@azure/msal-react';
import { SearchOutlined } from '@ant-design/icons';
import { AwardsName } from '../Atoms/AwardsName';
import { loginRequest } from '../../authConfig';
import Highlighter from 'react-highlight-words';
import { useNavigate } from 'react-router-dom';
import { TableProps } from 'antd/lib/table';
import { useMsal } from '@azure/msal-react';
import '../../../../src/App.css';
import '../Atoms/MyTable.css';
import axios from 'axios';

const { Content, Footer } = Layout;
const { Text } = Typography;

interface awardData {
    stage: any;
    stageName: any;
}
interface peersComments {
    assignedToName: string;
    comments: string;
    assignedByEmail: string;
}
interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
    tags: string[];
    id: any;
    nomineeDesignation: any;
    nomineeUnit: any;
    nomineeBu: any;
    nominatorName: any;
    nominatorDesignation: any;
    managerName: any;
    firstLevelApproverName: any;
    secondLevelApproverName: any;
    teamName: any;
    peersComments: peersComments[];
}

type DataIndex = keyof DataType;

const MainContent: React.FC<awardData> = ({ stage, stageName }) => {
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const baseURL = process.env.REACT_APP_API_URL;
    const [filterData, setFilteredData] = useState<any[]>([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState<{ [key: string]: boolean }>({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [comments, setComments] = useState<string>('');
    const [editable, setEditable] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [commentsData, setCommentsData] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [formmodal, setformmodal] = useState(false);
    const [nominatorComments, setNominatorComments] = useState(false);
    const [ncomm, setNcomm] = useState<string>('');
    const [employyeId, setEmployeeId] = useState<string>('');
    const [response, setResponse] = useState<string>('');
    const [recordData, setrecordData] = useState<any[]>([]);
    const [reviewFlag, setReviewFlag] = useState<boolean>(false);
    const [selectedEmployeeData, setSelectedEmployeeData] = useState<any[]>([]);
    const [getVote, SetgetVote] = useState<string>('');
    const [getComments, SetgetComments] = useState<string>('');
    const [teamModal, setTeamModal] = useState<boolean>(false);
    const [teamData, setTeamData] = useState<any[]>([]);
    const [userMail, setUserMail] = useState('');
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState<DataIndex | ''>('');
    const searchInput = useRef<InputRef>(null);
    const [adminNomineeModal, setAdminNomineeModal] = useState(false);
    const [isCriteriaVisible, setIsCriteriaVisible] = useState(false);
    const [selectedAward, setSelectedAward] = useState('');
    const [addPeers, setAddPeers] = useState<boolean>(false);
    const [peersEmails, setPeersEmails] = useState<string[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [recipientSearchResults, setRecipientSearchResults] = useState<any[]>([]);
    const [showAddPeersButton, setShowAddPeersButton] = useState<{ [key: string]: string }>({}); // key: nomination id

    //to get the access token
    const getAccessToken = async () => {
        const res = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        });
        return res.idToken
    }

    const openModal = (awardName: any) => (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setSelectedAward(awardName);
        setIsCriteriaVisible(true);
    };

    const closeModal = () => {
        setIsCriteriaVisible(false);
    };
    const handleSearch = (value: string, dataIndex: DataIndex) => {
        setSearchText(value);
        setSearchedColumn(dataIndex);
    };

    const handleReset = () => {
        setSearchText('');
        setSearchedColumn('');
    };
    // Fetch token utility (if not already present)
    const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        });
        return res.idToken;
    };

    // Peer email search effect
    useEffect(() => {
        const getCcList = async () => {
            if (searchTerm.length < 3) {
                setRecipientSearchResults([]);
                return;
            }
            try {
                const token = await fetchToken();
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/SearchInCoe?search=${encodeURIComponent(searchTerm)}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setRecipientSearchResults(response.data);
            } catch (error) {
                console.error('Error fetching recipients:', error);
            }
        };
        getCcList();
    }, [searchTerm]);

    const handlePeersEmailChange = (value: string[]) => {
        setPeersEmails(value);
    };

    // Check role and show Add Peers button if UH
    const checkRoleAndShowAddPeers = async (approvalId: any) => {
        try {
            console.log("Checking role for approvalId:", approvalId);
            const token = await fetchToken();
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/nominations/check-role/${approvalId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            console.log("Role check response:", res.data);
            if (res.data === "UH") {
                setShowAddPeersButton(prev => ({ ...prev, [approvalId]: "UH" }));
            } else if (res.data === "PM") {
                setShowAddPeersButton(prev => ({ ...prev, [approvalId]: "PM" }));
            }
        } catch (err) {
            setShowAddPeersButton(prev => ({ ...prev, [approvalId]: false }));
        }
    };
    const getColumnSearchProps = (dataIndex: DataIndex): TableColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} role='button' tabIndex={0} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSelectedKeys(value ? [value] : []);
                        handleSearch(value, dataIndex);
                    }}
                    onPressEnter={() => confirm()}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        onClick={() => {
                            clearFilters && clearFilters();
                            handleReset();
                        }}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const callMsGraph = async (token: any) => {
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${token}`);
        const response = await fetch(`https://graph.microsoft.com/v1.0/me?`, {
            method: "GET",
            headers,
        }).then((response) => response.json());
        return response;
    };

    const requestProfileData = useCallback(async () => {
        try {
            const response = await instance.acquireTokenSilent({
                scopes: ["User.Read", "User.Read.All"],
                authority: `https://login.microsoftonline.com/560ec2b0-df0c-4e8c-9848-a15718863bb6`,
            });
            const data = await callMsGraph(response.accessToken);
            localStorage.setItem("UserMail", data?.mail.toLowerCase());
            setUserMail(data?.mail?.toLowerCase());
        } catch (error) {
            console.error("Silent token acquisition failed, acquiring token using redirect");
            instance.loginRedirect(loginRequest);
        }
    }, [instance]);

    const conditionCheck = useCallback(async () => {
        if (userMail !== '') {
            try {
                const res = await instance.acquireTokenSilent({
                    ...loginRequest,
                    account: accounts[0],
                });
            } catch (error: any) {
                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    navigate('/no-access');
                } else {
                    console.error("An error occurred:", error);
                    navigate('/technical-error');
                }
            }
        }
    }, [instance, userMail, accounts, baseURL, navigate]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await requestProfileData();
                await conditionCheck();
            } catch (error) {
                navigate('/error');
            }
        };

        if (inProgress === InteractionStatus.None) {
            if (!isAuthenticated) {
                instance.loginRedirect({ scopes: ["User.Read", "User.Read.All"] });
            } else {
                fetchData();
            }
        }
    }, [instance, isAuthenticated, navigate, inProgress, requestProfileData, userMail, conditionCheck]);

    useEffect(() => {
        setFilteredData([]);
        setIsLoading(true);
        fetchdata();
    }, [stage]);

    useEffect(() => {
        emptyFunction();
    }, []);

    const getInitials = (name: string) => {
        const [firstName, lastName] = name.split(' ');
        if (!firstName || !lastName) {
            return '';
        }
        return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    };

    const getVoteKey = (stage: any) => {
        switch (stage) {
            case 0:
                return 'managerVote';
            case 1:
                return 'firstLevelApproverVote';
            case 2:
                return 'secondLevelApproverVote';
            case 3:
                return 'managerVote';
            case 4:
                return 'firstLevelApproverVote';
            case 5:
                return 'secondLevelApproverVote';
            default:
                return 'null';
        }
    };

    const getCommentsKey = (stage: any) => {
        switch (stage) {
            case 0:
                return 'managerComments';
            case 1:
                return 'firstLevelApproverComments';
            case 2:
                return 'secondLevelApproverComments';
            case 3:
                return 'managerComments';
            case 4:
                return 'firstLevelApproverComments';
            case 5:
                return 'secondLevelApproverComments';
            default:
                return 'null';
        }
    };

    const handleSave = async (id: any) => {
        let updatedTable = [...filterData];
        try {
            if (comments.length === 0) {
                notification.warning({
                    message: 'Warning',
                    description: 'Please add comments to submit your review. Thank you!',
                    placement: 'top',
                })
            }
            if (comments.length > 0 && comments.length < 50) {
                notification.error({
                    message: 'Error',
                    description: 'Comments should be atleast 50 characters long',
                    placement: 'top',

                });
                return;
            }
            if (comments.length > 50) {
                setEditable(false);
                const accessToken = await getAccessToken();
                const index = filterData.findIndex((item) => item.id === id);
                if (index !== -1) {
                    updatedTable[index][getCommentsKey(parseInt(stage))] = comments;
                    setFilteredData(updatedTable);
                    const res = await instance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0]
                    });
                    const patchData = JSON.stringify([
                        {
                            op: 'replace',
                            path: `/${getCommentsKey(parseInt(stage))}`,
                            value: comments
                        }
                    ]);
                    await axios.patch(`${baseURL}/api/nominations/${id}`, patchData, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${accessToken}`,
                        }
                    })
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleEdit = () => {
        setEditable(true);
    }
    const emptyFunction = () => {
        setIsButtonDisabled(prevStates => ({
            ...prevStates
        }));
    };
    useEffect(() => {
        console.log("Selected Employee Data (effect):", selectedEmployee);
    }, [selectedEmployee]);
    const handleCitationClick = async (id: string) => {
        const index = filterData.findIndex((item) => item.id === id);
        let updatedTable = [...filterData];
        setEmployeeId(id);
        formModal(updatedTable[index])
    }

    const handleButtonClick = async (id: string) => {
        console.log("Button clicked for ID:", id);
        const index = filterData.findIndex((item) => item.id === id);
        console.log("Index found:", index);
        let updatedTable = [...filterData];
        setEmployeeId(id);
        showModal(updatedTable[index])
        checkRoleAndShowAddPeers(id);

    }

    const handleModalButtonClick = async (id: any, value: string, empData: any) => {
        if (isModalVisible === true) {
            const index = filterData.findIndex((item) => item.id === id);
            setEmployeeId(id);
            setResponse(value);
            setSelectedEmployeeData(empData)
            handleSave(employyeId);
            handleClick(id, value);
        }
    }

    const handleClick = async (id: any, response: string) => {
        const index = filterData.findIndex((item) => item.id === id);
        let updatedTable = [...filterData];
        if (index !== -1) {
            setReviewFlag(true)
            updatedTable = [...filterData];
            setFilteredData(updatedTable);
            setCommentsData(true);
            if (comments.length > 50) {
                try {
                    const accessToken = await getAccessToken();
                    const patchData = JSON.stringify([
                        {
                            op: 'replace',
                            path: `/${getVoteKey(parseInt(stage))}`,
                            value: response
                        }
                    ]);
                    axios.patch(`${baseURL}/api/nominations/${employyeId}`, patchData, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${accessToken}`,
                        }
                    });
                    updatedTable[index][getVoteKey(parseInt(stage))] = response;
                    setFilteredData(updatedTable);
                    setIsDisabled(true)
                    setIsModalVisible(false)
                    if (response === 'Approved') {
                        notification.success({
                            message: `${response}`,
                            description: 'You have completed the review. Thank you!',
                            placement: 'top',
                        });
                        if (stage === '0' || stage === '3') {
                            let s = updatedTable[index];
                            //If the first and second level approver are same ie, ELT and Unit Head are same
                            if (s.managerVote === 'Approved') {
                                if (s.firstLevelApproverEmail === s.secondLevelApproverEmailId) {
                                    await axios.patch(`${baseURL}/api/nominations/${id}`,
                                        JSON.stringify([
                                            {
                                                op: 'replace',
                                                path: '/firstLevelApproverVote',
                                                value: 'Approved'
                                            },
                                            {
                                                op: 'replace',
                                                path: '/firstLevelApproverComments',
                                                value: ' '
                                            }
                                        ]), {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: `Bearer ${accessToken}`,
                                        }
                                    });
                                    await axios.post(`${baseURL}/api/notifications/email/approvers/2`, {
                                        "to": s.secondLevelApproverEmailId,
                                        "comments": "",
                                        "nomineeName": s.nomineeName,
                                        "reviewerName": "",
                                        "IsTeam": "false"
                                    }, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: `Bearer ${accessToken}`,
                                        }
                                    });
                                } else {
                                    let teamFlag = s.teamName ? "true" : "false";
                                    await axios.post(`${baseURL}/api/notifications/email/approvers/1`, {
                                        "to": s.firstLevelApproverEmail,
                                        "comments": "",
                                        "nomineeName": s.nomineeName,
                                        "reviewerName": "",
                                        "IsTeam": teamFlag
                                    }, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            Authorization: `Bearer ${accessToken}`,
                                        }
                                    });
                                }
                            }
                        }

                        if (stage === '1' || stage === '4') {
                            let s = updatedTable[index];
                            let teamFlag = s.teamName ? "true" : "false";
                            await axios.post(`${baseURL}/api/notifications/email/approvers/2`, {
                                "to": s.secondLevelApproverEmailId,
                                "comments": "",
                                "nomineeName": s.nomineeName,
                                "reviewerName": "",
                                "IsTeam": teamFlag
                            }, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${accessToken}`,
                                }
                            });
                        }
                    }
                    if (response === 'Rejected') {
                        notification.error({
                            message: `${response}`,
                            description: 'You have completed the review. Thank you!',
                            placement: 'top',
                        });
                        let s = updatedTable[index];
                        let nomineeName = s.nomineeName ? s.nomineeName : s.teamName;
                        let reviewerName = '';

                        // Set reviewerName based on the stage
                        //Only ELT should get Rejection Email
                        if (stage === '2' || stage === '5') {
                            reviewerName = s.secondLevelApproverName;
                            await axios.post(`${baseURL}/api/notifications/email/reject`, {
                                "to": s.nominatorEmail,
                                "comments": comments,
                                "nomineeName": nomineeName,
                                "reviewerName": reviewerName,
                                "IsTeam": "false"
                            }, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${accessToken}`,
                                }
                            });
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    setFilteredData(updatedTable);
                    setIsModalVisible(false);

                }
            }
        }

    };

    const showModal = (employee: any) => {
        if (stage === '10' || stage === '11') {
            setAdminNomineeModal(true);
        }
        else {
            setIsModalVisible(true);

        }

        setSelectedEmployee(employee);

        setComments(employee[getCommentsKey(parseInt(stage))]);
        if (employee[getCommentsKey(parseInt(stage))]) {
            setEditable(false);
            setComments(employee[getCommentsKey(parseInt(stage))])
        }
        else {
            setEditable(true);
            setComments('');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const formModal = (emploee: any) => {
        setSelectedEmployee(emploee);
        setformmodal(true);
    }

    const handleCancelForm = () => {
        if (stage === '10' || stage === '11') {
            setAdminNomineeModal(false);
        } else {
            setformmodal(false);
        }
    }

    const nominatorCommentsModal = (ncomm: any) => {
        setNcomm(ncomm)
        setNominatorComments(true);
    }

    const handleCancelComments = () => {
        setNominatorComments(false);
    }


    const handleCommentsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setComments(e.target.value);

    };


    const showTeamMembers = (employee: any) => {
        setTeamModal(true);
        setSelectedEmployee(employee);
        const teamMemberData = employee['teamMembers'];

        const teamMembers = teamMemberData.split("~").filter((item: any) => item.trim() !== '');

        setTeamData(teamMembers.map((member: any) => {
            const emailMatch = member.match(/^([^ ]+)@[^ ]+/);
            const nameMatch = member.match(/\(([^()]+) - /);
            const idMatch = member.match(/- ([^)]+)\)/);

            return {
                name: nameMatch ? nameMatch[1].trim() : '',
                employeeId: idMatch ? idMatch[1].trim() : '',
                email: emailMatch ? emailMatch[0].trim() : '',
            };
        }));
    };

    const handleCancelTeam = () => {
        setTeamModal(false);
    };


    const getColumns = (stage: any): TableProps<DataType>['columns'] => {
        const baseColumnsIndividual = [
            {
                title: "Nominee's Name",
                dataIndex: "nomineeName",
                key: 'name',
                sorter: (a: any, b: any) => a.nomineeName.localeCompare(b.nomineeName),
                sortDirections: ['descend', 'ascend'],
                fixed: 'left',
                ellipsis: true,
                ...getColumnSearchProps('name'),
            },
            {
                title: "Nominee's BU",
                dataIndex: "nomineeUnit",
                key: 'elt',
                sorter: (a: any, b: any) => a.nomineeUnit.localeCompare(b.nomineeUnit),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('nomineeUnit'),
            },
            {
                title: "Nominator's Name",
                dataIndex: "nominatorName",
                key: 'nominatorName',
                sorter: (a: any, b: any) => a.nominatorName.localeCompare(b.nominatorName),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('nominatorName'),
            },
            {
                title: "Nominator's Designation",
                dataIndex: "nominatorDesignation",
                key: 'nominatorDesignation',
                sorter: (a: any, b: any) => a.nominatorDesignation.localeCompare(b.nominatorDesignation),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('nominatorDesignation'),
            },
        ];

        const baseColumnsTeam = [
            {
                title: "Team Name",
                dataIndex: "teamName",
                key: 'teamName',
                sorter: (a: any, b: any) => a.teamName.localeCompare(b.teamName),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('teamName'),
            },
            {
                title: 'Team Members',
                dataIndex: 'Members',
                key: 'teamMembers',
                render: (text: string, record: any) => (
                    <Button style={{ cursor: 'pointer', color: 'blue', border: 'none' }} onClick={() => showTeamMembers(record)}>Team Details</Button>
                ),
            },

            {
                title: "Nominator's Name",
                dataIndex: "nominatorName",
                key: 'nominatorName',
                sorter: (a: any, b: any) => a.nominatorName.localeCompare(b.nominatorName),
                sortDirections: ['descend', 'ascend'],
                fixed: 'left',
                ellipsis: true,
                ...getColumnSearchProps('nominatorName'),
            },
            {
                title: "Nominator's Designation",
                dataIndex: "nominatorDesignation",
                key: 'nominatorDesignation',
                sorter: (a: any, b: any) => a.nominatorDesignation.localeCompare(b.nominatorDesignation),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('nominatorDesignation'),
            },
            {
                title: "Nominator's BU",
                dataIndex: "nominatorUnit",
                key: 'nomineeBu',
                sorter: (a: any, b: any) => a.nominatorUnit.localeCompare(b.nominatorUnit),
                sortDirections: ['descend', 'ascend'],
                ellipsis: true,
                ...getColumnSearchProps('nomineeBu'),
            },

        ];
        const actionColumn = {
            title: 'Action',
            key: 'id',
            fixed: 'right',
            render: (_: any, record: any) => {
                const isReviewed = record[getVoteKey(parseInt(stage))] !== 'Not Reviewed';
                setrecordData(record);
                if (record[getCommentsKey(parseInt(stage))] !== 'Not Reviewed') {
                    setReviewFlag(false);
                }
                return (
                    <Space size="middle">
                        {(stage === '10' || stage === '11') && (
                            <Button
                                onClick={() => handleButtonClick(record.id)}
                                disabled={(isReviewed && record[getCommentsKey(parseInt(stage))] != null) || (reviewFlag && record[getCommentsKey(parseInt(stage))] != null)}
                                style={{
                                    backgroundColor:
                                        (isReviewed && record[getCommentsKey(parseInt(stage))] != null) ||
                                            (reviewFlag && record[getCommentsKey(parseInt(stage))] != null)
                                            ? 'grey'
                                            : '#481558',
                                    color: 'white'
                                }}
                                type="primary"
                            >
                                Action
                            </Button>
                        )}
                        {(stage !== '10' && stage !== '11') && (
                            <Button
                                onClick={() => handleButtonClick(record.id)}
                                disabled={(isReviewed && record[getCommentsKey(parseInt(stage))] != null) || (reviewFlag && record[getCommentsKey(parseInt(stage))] != null)}
                                style={{
                                    backgroundColor:
                                        (isReviewed && record[getCommentsKey(parseInt(stage))] != null) ||
                                            (reviewFlag && record[getCommentsKey(parseInt(stage))] != null)
                                            ? 'grey'
                                            : '#481558',
                                    color: 'white'
                                }}
                                type="primary"
                            >
                                Review
                            </Button>
                        )}
                    </Space>
                );
            },
        };
        const statusColumn = {
            title: 'Status',
            dataIndex: getVoteKey(parseInt(stage)),
            key: 'status',
            fixed: 'right',
            sorter: (a: any, b: any) =>
                a[getVoteKey(parseInt(stage))].localeCompare(b[getVoteKey(parseInt(stage))]),
            render: (status: string) => (
                <Tag
                    className={status === 'Not Reviewed' ? 'flashy' : ''}
                    color={status === 'Approved' ? 'green' : status === 'Rejected' ? 'red' : 'blue'}
                >
                    {status}
                </Tag>
            ),
        };

        if (stage === '0' || stage === '1' || stage === '2' || stage === '10') {
            return [...baseColumnsIndividual, actionColumn, statusColumn] as TableColumnsType<DataType>;
        }
        if (stage === '3' || stage === '4' || stage === '5' || stage === '11') {
            return [...baseColumnsTeam, actionColumn, statusColumn] as TableColumnsType<DataType>;
        }
    }

    //Stage 0 - PM review Individual
    //Stage 1 - Unit head Review Individual
    //Stage 2 - ELT Review Individual
    //Stage 3 - PM review Team
    //Stage 4 - Unit Head review Team
    //Stage 5 - ELT Review Team
    //Stage 6 - 
    //Stage 7 -
    //Stage 8 - 
    //Stage 9 -            
    //Stage 10 - Admin Review Individual
    //Stage 11 - Admin Review Team


    const fetchdata = async () => {
        try {
            await requestProfileData();
            const userEmail = localStorage.getItem('UserMail');
            const accessToken = await getAccessToken();
            const response = await axios.get(`${baseURL}/api/nominations/users/${userEmail}/manager`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });

            const filterAndSetData = (data: any, criteria: (item: any) => boolean) => {
                const filteredData = data.filter(criteria).sort((a: any, b: any) => a.nomineeName.localeCompare(b.nomineeName));
                setFilteredData(filteredData);
            };

            console.log("Response Data:", response.data.responseData);

            // Skip logic helpers:
            // Scenario 2: Manager nominates teammate → skip manager stage
            // Scenario 3: Unit Head nominates → skip manager + unit head stages
            // Scenario 4: ELT (secondLevelApprover) nominates → skip manager + unit head stages
            const managerStageSkipped = (item: any) =>
                item.nominatorEmail === item.managerEmail;  // Manager is the nominator

            const unitHeadStageSkipped = (item: any) =>
                item.nominatorEmail === item.firstLevelApproverEmail;  // Unit Head is the nominator

            const eltNominated = (item: any) =>
                item.nominatorEmail === item.secondLevelApproverEmailId;  // ELT reviewer is the nominator

            // Manager stage is effectively approved when:
            //   - Manager voted Approved (normal), OR
            //   - Manager is the nominator (skip), OR
            //   - Unit Head is the nominator (skip), OR
            //   - ELT is the nominator (skip)
            const managerStageCleared = (item: any) =>
                item.managerVote === 'Approved' ||
                managerStageSkipped(item) ||
                unitHeadStageSkipped(item) ||
                eltNominated(item);

            // Unit Head stage is effectively approved when:
            //   - Unit Head voted Approved (normal), OR
            //   - Unit Head is the nominator (skip), OR
            //   - ELT is the nominator (skip)
            const unitHeadStageCleared = (item: any) =>
                item.firstLevelApproverVote === 'Approved' ||
                unitHeadStageSkipped(item) ||
                eltNominated(item);

            if (stage === '0' || stage === '1' || stage === '2' || stage === '10') {
                const filteredData = response.data.responseData.filter((item: any) => item.rewardName === AwardsName.IndividualAwards);
                if (stage === '0') {
                    // Show to manager ONLY if manager is NOT the nominator (scenario 2 skips this)
                    const reviewData = filteredData.filter((item: any) =>
                        item.managerEmail === userEmail && !managerStageSkipped(item)
                    );
                    filterAndSetData(reviewData, () => true);
                }
                else if (stage === '1') {
                    // Show to unit head if:
                    //   - Manager stage cleared (approved or skipped), AND
                    //   - Unit Head is NOT the nominator (scenario 3 skips unit head too)
                    const reviewData = filteredData.filter((item: any) =>
                        item.firstLevelApproverEmail === userEmail &&
                        managerStageCleared(item) &&
                        !unitHeadStageSkipped(item)
                    );
                    filterAndSetData(reviewData, () => true);
                } else if (stage === '2') {
                    // Show to ELT if:
                    //   - Both manager and unit head stages are cleared (approved or skipped)
                    const reviewData = filteredData.filter((item: any) =>
                        item.secondLevelApproverEmailId === userEmail &&
                        managerStageCleared(item) &&
                        unitHeadStageCleared(item)
                    );
                    filterAndSetData(reviewData, () => true);
                } else {
                    filterAndSetData(filteredData, () => true);
                }
            }

            if (stage === '3' || stage === '4' || stage === '5' || stage === '11') {
                const filteredData = response.data.responseData.filter((item: any) => item.rewardName === AwardsName.TeamAwards);

                if (stage === '3') {
                    // Show to manager ONLY if manager is NOT the nominator
                    const reviewData = filteredData.filter((item: any) =>
                        item.managerEmail === userEmail && !managerStageSkipped(item)
                    );
                    filterAndSetData(reviewData, () => true);
                }
                else if (stage === '4') {
                    // Show to unit head if manager stage cleared and unit head is not the nominator
                    const reviewData = filteredData.filter((item: any) =>
                        item.firstLevelApproverEmail === userEmail &&
                        managerStageCleared(item) &&
                        !unitHeadStageSkipped(item)
                    );
                    filterAndSetData(reviewData, () => true);
                } else if (stage === '5') {
                    // Show to ELT if both manager and unit head stages are cleared
                    const reviewData = filteredData.filter((item: any) =>
                        item.secondLevelApproverEmailId === userEmail &&
                        managerStageCleared(item) &&
                        unitHeadStageCleared(item)
                    );
                    filterAndSetData(reviewData, () => true);
                } else if (stage === '11') {
                    const filteredData = response.data.responseData.filter((item: any) => item.rewardName === AwardsName.TeamAwards);
                    filterAndSetData(filteredData, () => true);
                }
                else {
                    filterAndSetData(filteredData, () => true);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div >
            <div style={{ flex: '1', padding: '16px', overflowY: 'auto' }}>
                <h3 style={{ marginLeft: '24px', marginTop: '16px' }}>{stageName}{(
                    <a href="#" onClick={openModal("ACE Awards")}> (Click here to view criteria)</a>
                )}</h3>
                <div className='mainContent' style={{ display: 'flex', width: '100%' }}>
                    <Content
                        style={{
                            margin: '4px',
                            padding: 4,
                            minHeight: '80px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    >
                        {isCriteriaVisible && <EligibilityModal
                            visible={isCriteriaVisible}
                            onClose={closeModal}
                            awardName={selectedAward}
                        />}
                        <div>
                            {isLoading ? (
                                <Spin tip="Loading..." fullscreen size='large'>
                                    <Alert message="Fetching data" type="info" />
                                </Spin>
                            ) : (
                                <div>
                                    <Layout
                                        style={{

                                            background: colorBgContainer,
                                            borderRadius: borderRadiusLG,
                                        }}
                                    >
                                        {filterData.length > 0 ? (
                                            <div style={{ width: '180vh', overflow: 'auto', margin: '0px', padding: '0px' }} >
                                                <Table<DataType>
                                                    columns={getColumns(stage)}
                                                    dataSource={filterData}
                                                    pagination={{ pageSize: 6 }}
                                                    rowKey={id => id.id}
                                                    bordered
                                                    scroll={{ x: true }}
                                                />
                                            </div>) : (<p>Currently, you do not have any nominatons under this queue.</p>)}
                                        <Modal
                                            title="Nominee Details"
                                            open={isModalVisible}
                                            onCancel={handleCancel}
                                            footer={[
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    {/* Left-aligned buttons */}
                                                    <div>
                                                        <Button key="edit" onClick={handleEdit} disabled={!comments || editable} style={{ marginRight: '10px' }}>
                                                            Edit
                                                        </Button>
                                                        <Button key="save" type="primary" onClick={() => handleSave(selectedEmployee.id)} disabled={!comments || !editable} style={{ marginRight: '10px' }}>
                                                            Save
                                                        </Button>
                                                        <Button key="close" onClick={handleCancel}>
                                                            Close
                                                        </Button>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            onClick={() => handleModalButtonClick(employyeId, 'Approved', selectedEmployee)}
                                                            disabled={reviewFlag}
                                                            style={{ backgroundColor: reviewFlag ? 'grey' : '#52C41A', marginLeft: '10px' }}
                                                            type="primary"
                                                        >
                                                            Approve
                                                        </Button>
                                                        <Button
                                                            onClick={() => handleModalButtonClick(employyeId, 'Rejected', selectedEmployee)}
                                                            disabled={reviewFlag}
                                                            style={{ backgroundColor: reviewFlag ? 'grey' : 'red', marginLeft: '10px' }}
                                                            type="primary"
                                                        >
                                                            Reject
                                                        </Button>
                                                    </div>
                                                </div>
                                            ]}
                                            width={800}
                                        >
                                            {selectedEmployee && (
                                                <>
                                                    <div className="nominee-header">
                                                        {selectedEmployee.rewardName === AwardsName.IndividualAwards && (
                                                            <div className="initials-circle">
                                                                <Text strong className="initials-text">{getInitials(selectedEmployee.nomineeName)}</Text>
                                                            </div>
                                                        )}

                                                        <div className="nominee-details">
                                                            {selectedEmployee.rewardName === AwardsName.IndividualAwards && (
                                                                <>
                                                                    <Text strong>{selectedEmployee.nomineeName}</Text><br />
                                                                    <Text type="secondary">{selectedEmployee.nomineeDesignation} | {selectedEmployee.nomineeUnit}</Text>
                                                                </>
                                                            )}
                                                            {selectedEmployee.rewardName === AwardsName.TeamAwards && (
                                                                <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                                                                    <Col span={8}>
                                                                        <Text strong>{selectedEmployee.teamName}</Text>
                                                                    </Col>
                                                                    <Col>
                                                                        <Button type="primary" onClick={() => showTeamMembers(selectedEmployee)}>Team Details</Button>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <Divider />

                                                    <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                                                        <Col span={8}>
                                                            <Text strong>Nominator</Text>
                                                            <br />
                                                            <Text>{selectedEmployee.nominatorName}</Text>
                                                        </Col>
                                                        <Col span={16}>
                                                            <Text strong>Nominator's Citation</Text>
                                                            <br />
                                                            <Button type="primary" onClick={() => formModal(selectedEmployee)}>View Nomination Details</Button>
                                                        </Col>
                                                    </Row>
                                                    {stage !== '0' && stage !== '3' && (
                                                        <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                                                            <Col span={8}>
                                                                <Text strong>Manager</Text>
                                                                <br />
                                                                <Text>{selectedEmployee.managerName}</Text>
                                                            </Col>
                                                            <Col span={16}>
                                                                <Text strong>Manager's Comments</Text>
                                                                <br />
                                                                <Text>{selectedEmployee.managerComments}</Text>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {
                                                        (stage === '2' || stage === '5') && (
                                                            <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                                                                <Col span={8}>
                                                                    <Text strong>First Level Approver</Text>
                                                                    <br />
                                                                    <Text>{selectedEmployee.firstLevelApproverName}</Text>
                                                                </Col>
                                                                <Col span={16}>
                                                                    <Text strong>First Level Approver's Comments</Text>
                                                                    <br />
                                                                    <Text>{selectedEmployee.firstLevelApproverComments}</Text>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                    {Array.isArray(selectedEmployee?.peerComments) && selectedEmployee.peerComments.length > 0 && (
                                                        <>
                                                            <Row gutter={[16, 16]} style={{ marginTop: '16px', fontWeight: 'bold' }}>
                                                                <Col span={8}> <Text strong>Additional Reviewer Name</Text></Col>
                                                                <Col span={8}><Text strong>Additional Reviewers Comments</Text></Col>
                                                            </Row>
                                                            {selectedEmployee.peerComments.map((peer: peersComments, idx: number) => (
                                                                <Row key={idx} gutter={[16, 16]} style={{ marginTop: '8px' }}>
                                                                    <Col span={8}>
                                                                        <Text>{peer.assignedToName}</Text>
                                                                    </Col>
                                                                    <Col span={16}>
                                                                        <Text>{peer.comments}</Text>
                                                                    </Col>
                                                                </Row>
                                                            ))}
                                                        </>
                                                    )}
                                                    {(stage === '1' || stage === '4') && showAddPeersButton[selectedEmployee?.id]=="UH" && !addPeers && (
                                                        <Button
                                                            style={{ marginTop: 16, background: '#1890ff', color: 'white' }}
                                                            onClick={() => setAddPeers(true)}
                                                        >
                                                            Add additional reviewers 
                                                        </Button>
                                                    )}
                                                    {(stage === '0' || stage === '3') && showAddPeersButton[selectedEmployee?.id]=="PM" && !addPeers && (
                                                        <Button
                                                            style={{ marginTop: 16, background: '#1890ff', color: 'white' }}
                                                            onClick={() => setAddPeers(true)}
                                                        >
                                                            Add additional reviewers 
                                                        </Button>
                                                    )}
                                                    {addPeers && (
                                                        <Form layout="vertical">
                                                            <Form.Item>
                                                                <Checkbox
                                                                    checked={addPeers}
                                                                    onChange={e => setAddPeers(e.target.checked)}
                                                                    style={{ marginTop: '10px' }}
                                                                >
                                                                    Add Additional reviewers
                                                                </Checkbox>
                                                                <div style={{display:'flex'}}>
                                                                    <div>
                                                                        <Select
                                                                            mode="tags"
                                                                            style={{ width: '100%', marginTop: '10px' }}
                                                                            placeholder="Enter email addresses"
                                                                            onSearch={setSearchTerm}
                                                                            onChange={handlePeersEmailChange}
                                                                            value={peersEmails}
                                                                            maxTagCount={2}
                                                                        >
                                                                            {peersEmails.length < 2 && recipientSearchResults.length > 0 && recipientSearchResults.map(email => (
                                                                                <Select.Option key={email.id} value={email.email}>
                                                                                    {email.email}
                                                                                </Select.Option>
                                                                            ))}
                                                                        </Select>
                                                                        <p style={{ margin: '0px 0px 14px', padding: '0px', fontSize: '12px', color: 'rgb(136, 136, 136)' }}>
                                                                            Requesting feedback from additional reviewers (2 Max)
                                                                        </p>
                                                                    </div>
                                                                    <Button
                                                                        type="primary"
                                                                        disabled={peersEmails.length === 0}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const token = await fetchToken();
                                                                                const userId = localStorage.getItem('UserId');
                                                                                if (!userId) {
                                                                                    message.error('User ID not found');
                                                                                    return;
                                                                                }
                                                                                const addPeerListDto = {
                                                                                    addPeerCommentsDto: {
                                                                                        approvalId: selectedEmployee.approvalId,
                                                                                        assignedBy: userId,
                                                                                        createdBy: userId,
                                                                                    },
                                                                                    assignedTo: peersEmails,
                                                                                };
                                                                                await axios.post(`${process.env.REACT_APP_API_URL}/api/AddPeerComment/add-peer`, addPeerListDto, {
                                                                                    headers: {
                                                                                        'Content-Type': 'application/json',
                                                                                        Authorization: `Bearer ${token}`
                                                                                    }
                                                                                });
                                                                                message.success('Peers added successfully!');
                                                                                setAddPeers(false);
                                                                                setPeersEmails([]);
                                                                            } catch (err) {
                                                                                message.error('Failed to add peers');
                                                                            }
                                                                        }}
                                                                        style={{ marginLeft: '10px', marginTop: '10px' }}
                                                                    >
                                                                        Submit
                                                                    </Button>
                                                                </div>
                                                            </Form.Item>
                                                        </Form>
                                                    )}

                                                    <div style={{ marginTop: '20px' }}>
                                                        <p><strong>Add your Comments</strong></p>
                                                        <textarea
                                                            style={{
                                                                width: '100%',
                                                                height: '100px',
                                                                marginTop: '10px',
                                                                borderRadius: '5px',
                                                                padding: '8px',
                                                                border: '1px solid #ccc',
                                                            }}
                                                            placeholder="Leave your comments here..."
                                                            value={comments}
                                                            onChange={handleCommentsChange}
                                                            disabled={!editable}
                                                        />
                                                        <p style={{ marginTop: '5px', color: 'gray', fontSize: '12px' }}>
                                                            Minimum 50 Characters
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </Modal>


                                        <TeamDetailsModal
                                            visible={teamModal}
                                            onCancel={handleCancelTeam}
                                            empData={selectedEmployee}
                                            teamData={teamData}
                                        />

                                        <NomineeDetailsModal
                                            visible={formmodal}
                                            onCancel={handleCancelForm}
                                            empData={selectedEmployee}

                                        />
                                        <Modal

                                            open={nominatorComments}
                                            onCancel={handleCancelComments}
                                            footer={[
                                                <Button key="close" onClick={handleCancelComments}>
                                                    Close
                                                </Button>,
                                            ]}
                                        >
                                            <p><strong>Comments: <br></br> </strong>{ncomm} </p>

                                        </Modal>
                                        <AdminNomineeModal
                                            visible={adminNomineeModal}
                                            onCancel={handleCancelForm}
                                            empData={selectedEmployee}
                                        />
                                    </Layout>

                                    <Footer
                                        style={{
                                            textAlign: 'center',
                                        }}
                                    >
                                        <div key="copyright" className='copyright'>
                                            Copyright ©{new Date().getFullYear()} Created by Aptean
                                        </div>
                                    </Footer>
                                </div>
                            )}
                        </div>
                    </Content>
                </div >
            </div >
        </div >


    )
}

export default MainContent